import FFormSubmitBtnMDP from "@/components/FFormSubmitBtnMDP";
import FFormDrawerMDP, { FFormChildMDP } from "@/components/form/FFormDrawerMDP";
import FFormMDP from "@/components/form/FFormMDP";
import FEmailFieldMDP from "@/components/form/field/FEmailFieldMDP";
import FPhoneFieldMDP from "@/components/form/field/FPhoneFieldMDP";
import FTextareaMDP from "@/components/form/field/FTextareaMDP";
import FTextFieldMDP from "@/components/form/field/FTextFieldMDP";
import FSearchGridMDP from "@/components/generic/FSearchGridMDP";

export default class AddCreditorNotesFFomMDP extends FFormDrawerMDP {
    childMDP: FFormChildMDP =  new FFormChildMDP();
    constructor(props: {parent: any;onClick: () => void;onClose: () => void;isVisible: boolean}) {
        super({myRefName:"AddCreditorNotesFFomRef",isVisible: props.isVisible,onClose: props.onClose});
        this.addField(new FTextFieldMDP({
            dataSelectorKey:"collectorName",
            label:"Collector Name",
            parentMDP: this.childMDP,
            boundaryClass: "col-12",
            mandatory: true
        }))
        .addField(new FTextFieldMDP({
            dataSelectorKey:"agencyName",
            label:"Agency Name",
            parentMDP: this.childMDP,
            boundaryClass: "col-12",
            mandatory: false
        }))

        .addField(new FEmailFieldMDP({
            dataSelectorKey:"collectorEmailId",
            label:"Collector EmailId",
            parentMDP: this.childMDP,
            boundaryClass: "col-12",
            mandatory: false
        }))

        .addField(new FPhoneFieldMDP({
            dataSelectorKey:"creditorPhoneNumber",
            label:"Creditor Phone Number",
            parentMDP: this.childMDP,
            boundaryClass: "col-12",
            mandatory: true
        }))
        .addField(new FPhoneFieldMDP({
            dataSelectorKey:"secondaryPhoneNumber",
            label:"Secondary Phone Number",
            parentMDP: this.childMDP,
            boundaryClass: "col-12",
            mandatory: false
        }))

        .addField(new FTextareaMDP({
            dataSelectorKey:"notes",
            label:"Notes",
            parentMDP: this.childMDP,
            boundaryClass: "col-12",
            mandatory: true
        }))
        
        .addAction(new FFormSubmitBtnMDP({label:"Submit",onClick: () => {props.onClick()}}))
    }
}